<template>
	<div class="museum-content">
		<swiper class="swiper-container" :options="swiperOption" ref="mySwiper" @slideChange="onSlideChange">
			<swiper-slide class="swiper-slide" v-for="(item,index) in guideMuseumNew" :key="index">
				<div class="slider-item">
					<div class="item-title">{{item.exhibitName}}<i @click.stop.prevent="playOrPause(index)" :class="{active:isActive&&currentIndex==index}"></i></div>
					<img class="slider-img" :src="item.exhibitImgurl" alt="">
				</div>
			</swiper-slide>
		</swiper>
		<div class="pull"></div>
		<audio src id="museumaudio1" hidden ref="museumaudio"></audio>
		<div class="finapage" v-if="isfinapage">已到最后一页</div>
		<div class="fanhui" @click="fanhuiFn">
		</div>
		<transition name="fade">
			<loading v-if="isloading" :msg="loadingTxt" :loadingVoice="loadingVoice" @func="closedFn"></loading>
		</transition>
	</div>
</template>

<script>
	import loading from "@/components/loadingComponent/loading";
	// import {
	// 	swiper,
	// 	swiperSlide
	// } from 'vue-awesome-swiper';
	export default {
		name: 'carrousel',
		data() {
			return {
				isloading:false,
				loadingTxt:'音频加载中',
				loadingVoice:false,
				swiperOption: {
					initialSlide:'0',
					autoplay: {
						disableOnInteraction: false, //用户操作后是否禁止自动循环
					}, //可选选项，自动滑动
					speed: 200, //切换速度，即slider自动滑动开始到结束的时间（单位ms）
					loop: false, //循环切换
					direction: 'vertical',
					observer: true, //修改swiper自己或子元素时，自动初始化swiper					
					observeParents: true,
				},
				museumAudio: '',
				currentIndex: -1,
				isActive: false,
				isPlay:false,
				isfinapage:false,
				guideMuseumAll:[],
				guideMuseumNew:[],
				page:2,
				pageSize:10,
				museumUuid:'',
			}
		},
		components: {
			loading,

		},
		props: {
			guideMuseum: Array,
			guideMuseumNum:Number
		},
		computed: {
			swiper() {
				return this.$refs.mySwiper.$swiper
			}
		},
		created() {
			const guideMuseum = this.guideMuseum
			this.museumUuid = this.guideMuseum[0].uuid
		},
		mounted() {
			this.museumAudio = this.$refs.museumaudio;
			this.guideMuseumNew = this.guideMuseum;
			this.currentIndex = 0;
			this.museumAudio.src = this.guideMuseumNew[this.currentIndex].exhibitAudio;
			this.museumAudio.play();		
			this.getAllMuseumExhibitsList();
			this.monitorAudioPlay();

		},
		methods: {
			closedFn(){
				this.isloading = false
			},
			getAllMuseumExhibitsList(){
				const qs = require("qs");
				const data = {
					uuid:this.museumUuid,
					page:this.page,
					pageSize:this.pageSize					
				}
				this.$http.post("https://www.1314zhilv.com/travelwalkman/museum/getAllMuseumExhibitsList",qs.stringify(data)).then(res => {
						this.guideMuseumAll = res ;
						this.guideMuseumNew = this.guideMuseumNew.concat(res.ExhibitsList);				
				});
			},
			playOrPause() {
				if (!this.museumAudio.paused) {
					this.isActive = true;
					this.isPlay = true;
					this.museumAudio.pause();
				} else {
					this.isActive = false;
					this.isPlay = false;
					this.museumAudio.play();
				}
			},
			onSlideChange(e) {
				const index = e.activeIndex;
				this.currentIndex = index
				this.museumAudio.src = this.guideMuseumNew[index].exhibitAudio;
				if(index>=this.guideMuseumNum-1){//最后一个
				console.log(index,this.guideMuseumNum-1,'最后一个')
					this.isfinapage = true;
					setTimeout(()=>{
						this.isfinapage = false;
					},2000)
				}else{
					if(index%5==0){
						this.page ++;
						this.getAllMuseumExhibitsList();				
					}			
				}
				if (!this.isPlay) {
					this.isActive = false;
					this.museumAudio.play();
				} else {
					this.isActive = true;
					this.museumAudio.pause();
				}
			},
			monitorAudioPlay() {
				this.museumAudio.addEventListener("waiting", () => {
					this.isloading = true;
					setTimeout(()=>{
						this.isloading = false;
					},2000)
				}, false);
				this.museumAudio.addEventListener("play", () => {
					this.isloading = false;
				}, false);
				this.museumAudio.addEventListener("pause", () => {
					this.isloading = false;
				}, false);
				this.museumAudio.addEventListener("ended", () => {
					console.log(this.currentIndex,this.guideMuseumNum-1)
					if(this.currentIndex<this.guideMuseumNum-1){
						this.currentIndex++;
						this.swiper.slideTo(this.currentIndex, 200, false);
						setTimeout(()=>{
							this.museumAudio.src = this.guideMuseumNew[this.currentIndex].exhibitAudio;
							this.museumAudio.play();
						},200)
					}else if(this.currentIndex>=this.guideMuseumNum-1){
						this.$emit('isMuseumFn',false);
					}

				}, false);
				this.museumAudio.addEventListener("timeupdate", () => {
					this.isloading = false;
				}, false);
			},
			fanhuiFn(){
					this.$emit('isMuseumFn',false);
			}
		}
	}
</script>

<style lang="less">
	.museum-content {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 5;
		background: rgba(255, 255, 255, 1);

		.swiper-container,
		.swiper-wrapper {
			width: 100%;
			height: 100% !important;

			.swiper-slide {
				width: 100%;
				height: 100% !important;
			}
		}

		.slider-item {
			width: 100%;
			height: 100%;

			.item-title {
				width: 100%;
				height: 2.24rem;
				font-size: 0.44rem;
				font-weight: 700;
				text-align: center;
				padding: 0 0.4rem;
				box-sizing: border-box;
				-webkit-box-sizing: border-box;
				line-height: 0.54rem;
				padding-top: 0.22rem;

				i {
					width: 0.44rem;
					height: 0.44rem;
					display: inline-block;
					background: url(http://www.1314zhilv.com/resources/xcx/mdxcximg/sound.png) no-repeat;
					background-size: cover;
					position: relative;
					top: 0.1rem;
					left: 0.2rem;
				}

				i.active {
					background: url(http://www.1314zhilv.com/resources/xcx/mdxcximg/nosound.png) no-repeat;
					background-size: cover;
				}
			}

			.slider-img {
				width: 100%;
				height: 6.86rem;
				position: absolute;
				left: 0;
				top: 2.52rem;
			}
		}

		.pull {
			width: 0.72rem;
			height: 0.68rem;
			background: url(http://www.1314zhilv.com/resources/xcx/mdxcximg/downjiantou.png) no-repeat;
			background-size: cover;
			position: fixed;
			left: 3.39rem;
			bottom: 0.15rem;
		}
	}
	.finapage{
			width: 1.8rem;
			text-align: center;
			color:#fff;
			font-size: 0.16rem;
			padding:0.1rem 0rem;
			box-sizing: border-box;
			background: rgba(0,0,0,0.6);
			border-radius: 0.1rem;
			position: fixed;
			left:50%;
			top:45%;
			margin-left:-0.9rem;
			z-index: 2;
	}
	.fanhui{
		width: 0.72rem;
		height:0.68rem;
		background: url(../../../static/img/gcclose.png) no-repeat;
		background-size: cover;
		position: fixed;
		right: 0.45rem;
		bottom: 0.35rem;
		z-index: 2;
	}
</style>



// WEBPACK FOOTER //
// src/components/museumComponent/museum.vue